import { render, staticRenderFns } from "./AdminPagesEdit.vue?vue&type=template&id=ceb4d832&"
import script from "./AdminPagesEdit.vue?vue&type=script&lang=js&"
export * from "./AdminPagesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports